var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-top",on:{"click":_vm.backClick}},[_c('img',{attrs:{"src":require("assets/img/music/play.svg"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }